export default __webpack_public_path__ + "static/media/bg_2.e2646e9b.png";